<div class="document-row" *transloco="let t; prefix: 'assetOverview.complianceRow'">
  <div class="document-row-left">
    <div class="document-row-left-title">
      <span class="document-row-left-title-name">{{ row.documentName | lookupLabel:'assetOverview.documentTypeNames' }}</span>
      @if (row.complianceStandard) {
        <span class="document-row-left-title-dot"></span>
        <span class="document-row-left-title-standard">{{ row.complianceStandard }}</span>
      }
    </div>
    @if (row.expirationDate) {
      <span class="document-row-left-expiry">
        {{ isDocumentExpired ? t('expired') : t('expiring') }} {{ row.expirationDate | date:'dd MMM yyyy' }}
      </span>
    }
  </div>

  <div class="document-row-right">
    <span class="document-row-right-status-pill" [ngClass]="{
        'document-row-right-status-pill--valid': status === 'valid',
        'document-row-right-status-pill--expiring-soon': status === 'expiring-soon',
        'document-row-right-status-pill--non-compliant': status === 'non-compliant'
      }">
      <span class="document-row-right-status-pill-icon">
        @if (status === 'non-compliant') {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.96736 1.33203C4.3087 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6607 1.33203 7.96736 1.33203ZM8.66536 11.332H7.33203V9.9987H8.66536V11.332ZM8.66536 8.66536H7.33203V4.66536H8.66536V8.66536Z" fill="#FF7F00"/>
          </svg>
        } @else if (status === 'expiring-soon') {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.96736 1.33203C4.3087 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6607 1.33203 7.96736 1.33203ZM8.66536 11.332H7.33203V9.9987H8.66536V11.332ZM8.66536 8.66536H7.33203V4.66536H8.66536V8.66536Z" fill="#F4BC2B"/>
          </svg>
        } @else {
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z" fill="#50AD41"/>
          </svg>
        }
      </span>
      <span class="document-row-right-status-pill-label">
        {{ statusLabel }}
      </span>
    </span>

    <div class="document-row-right-actions">
      <button class="document-action-btn" [title]="t('actions.view')" (click)="onViewClick(row)">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 9C10.358 9 9 10.359 9 12C9 13.642 10.358 15 12 15C13.641 15 15 13.642 15 12C15 10.359 13.641 9 12 9Z" fill="#9FA1A4"/>
          <path d="M12.0003 5C4.36729 5 2.07329 11.617 2.05229 11.684L1.94629 12L2.05129 12.316C2.07329 12.383 4.36729 19 12.0003 19C19.6333 19 21.9273 12.383 21.9483 12.316L22.0543 12L21.9493 11.684C21.9273 11.617 19.6333 5 12.0003 5ZM12.0003 17C6.64929 17 4.57629 13.154 4.07429 12C4.57829 10.842 6.65229 7 12.0003 7C17.3513 7 19.4243 10.846 19.9263 12C19.4223 13.158 17.3483 17 12.0003 17Z" fill="#9FA1A4"/>
        </svg>
      </button>
      <button class="document-action-btn" [title]="t('actions.edit')" (click)="onEditClick(row)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.00017 21.0001C4.08117 21.0001 4.16217 20.9901 4.24217 20.9701L8.24217 19.9701C8.41817 19.9261 8.57917 19.8351 8.70717 19.7071L21.0002 7.41411C21.3782 7.03611 21.5862 6.53411 21.5862 6.00011C21.5862 5.46611 21.3782 4.96411 21.0002 4.58611L19.4142 3.00011C18.6582 2.24411 17.3422 2.24411 16.5862 3.00011L4.29317 15.2931C4.16517 15.4211 4.07417 15.5821 4.03017 15.7571L3.03017 19.7571C2.94417 20.0981 3.04517 20.4581 3.29317 20.7071C3.48217 20.8971 3.73817 21.0001 4.00017 21.0001ZM18.0002 4.41411L19.5862 6.00011L18.0002 7.58611L16.4142 6.00011L18.0002 4.41411ZM5.90317 16.5111L15.0002 7.41411L16.5862 9.00011L7.48817 18.0971L5.37417 18.6251L5.90317 16.5111Z" fill="#9FA1A4"/>
        </svg>
      </button>
      <button class="document-action-btn" [title]="t('actions.delete')" (click)="onDeleteClick(row)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H18H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H6H3V8H5V20ZM9 4H15V6H9V4ZM8 8H16H17L17.001 20H7V8H8Z" fill="#9FA1A4"/>
          <path d="M9 10H11V18H9V10ZM13 10H15V18H13V10Z" fill="#9FA1A4"/>
        </svg>
      </button>
    </div>
  </div>
</div>